export default __webpack_public_path__ + "static/media/12-460x460.1d287bf9.jpeg";